import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    hasPendingChanges: false,
    showModal: false,
};
const pendingChangesSlice = createSlice({
    name: 'pendingchanges',
    initialState,
    reducers: {
        setHasPendingChanges(state) {
            state.hasPendingChanges = true;
        },
        showPendingChangesModal(state) {
            state.hasPendingChanges = true;
            state.showModal = true;
        },
        resetPendingChanges(state) {
            Object.assign(state, initialState);
        },
        closeAndKeepChanges(state) {
            state.showModal = false;
        },
    },
});
export const { setHasPendingChanges, showPendingChangesModal, resetPendingChanges, closeAndKeepChanges } = pendingChangesSlice.actions;
export default pendingChangesSlice.reducer;
